/**
 * Copyright (c) 2019 2020 2021 2022 AIGIA. All Rights Reserved.
 * see license.txt
 */

"use strict";

import {Component, Inject, OnInit} from "@angular/core";

import {Location} from "@angular/common";

import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";

import {LogoutDialogComponent} from "../../../platform/auth/logout-dialog/logout-dialog.component";

import {Router} from "@angular/router";
import {AigiaAuthService} from "../aigia-auth.service";
import {IErrorObject} from "../../../../../types/platform/universe";
import {TranslateService} from "@ngx-translate/core";

/**
 *
 *
 * @since 0.01
 */
@Component({
	selector: "aigia-logout-dialog",
	styleUrls: ["../aigia-auth.component.css"],
	templateUrl: "./aigia-logout-dialog.component.html",
	providers: [
		Location,
	],
})
export class AigiaLogoutDialogComponent extends LogoutDialogComponent implements OnInit {

	/**
	 *
	 * @param data
	 * @param matDialogRef
	 * @param location
	 * @param snackbar
	 * @param auth
	 * @param router
	 * @param translate
	 */
	constructor(
		@Inject(MAT_DIALOG_DATA)
		public data: any,
		public matDialogRef: MatDialogRef<AigiaLogoutDialogComponent>,
		public location: Location,
		public snackbar: MatSnackBar,
		public auth: AigiaAuthService,
		protected router: Router,
		public translate: TranslateService
	) {
		super(data, matDialogRef, location, snackbar, auth, router);
	}

	/**
	 * todo
	 */
	private mapToQuery(map: any): string {
		let result: string = "";
		let sep: string = "?";
		Object.keys(map).forEach((key) => {
			result += sep + key + "=" + map[key];
			sep = "&";
		})
		return result;
	}

	/**
	 * todo
	 */
	public onAccept(): void {
		this.Progress(true);
		this.auth.logout((error: IErrorObject, result: any) => {
			if (!error) {
				if (this.data.content.params) {
					this.location.replaceState(this.mapToQuery(this.data.content.params));
				} else {
					this.location.replaceState("");
				}
				this.matDialogRef.close(this.data);
			} else {
				this.errorBar(error);
			}
			this.Progress(false);
		});
	}

}
